import React, { useEffect, useState } from 'react'
import Editor, { Toolbar } from 'react-simple-wysiwyg'

const MorseCodeProvider = ({
  patientDBdata,
  diagnosisName,
  setPatientDBdata,
  noteID,
}) => {
  console.log(diagnosisName, 'diagnosisName here')

  const [finalScore, setFinalScore] = useState(0)
  const [date, setDate] = useState('')
  const [tempHtml, setTempHtml] = useState('')
  const [isHavingMorseScore, setIsHavingMorseScore] = useState(false)

    const morseData =
    patientDBdata?.currentNote?.data?.MorseScore?.[diagnosisName]

  const savedHtml =
    patientDBdata?.currentNote?.data?.freeTypesEverything?.MorseScore?.[diagnosisName]

  if (!diagnosisName || !morseData) {
    return null
  }

  // useEffect(() => {
  //   if (!diagnosisName) return

  //   const savedHtml = patientDBdata?.currentNote?.data?.freeTypesEverything?.MorseScore?.[diagnosisName]
  //   const morseData = patientDBdata?.currentNote?.data?.MorseScore?.[diagnosisName]
  //   if (morseData) {
  //     setFinalScore(morseData.finalScore)
  //     setDate(morseData.date)
  //     setTempHtml(savedHtml ? savedHtml : `
  //       <div>
  //         <div>Score: ${morseData.finalScore}</div>
  //         <div>Date: ${morseData.date}</div>
  //       </div>
  //     `)
  //     setIsHavingMorseScore(true)
  //   } else {
  //     setIsHavingMorseScore(false)
  //   }
  // }, [patientDBdata, diagnosisName])

    useEffect(() => {
    const generatedHtml = `
      <div>
        <div>Score: ${morseData.finalScore}</div>
        <div>Date: ${morseData.date}</div>
      </div>
    `

    const initialHtml = savedHtml || generatedHtml
    setTempHtml(initialHtml)

    if (!savedHtml) {
      setPatientDBdata(prev => ({
        ...prev,
        currentNote: {
          ...prev.currentNote,
          data: {
            ...prev.currentNote.data,
            freeTypesEverything: {
              ...(prev.currentNote.data?.freeTypesEverything || {}),
              MorseScore: {
                ...(prev.currentNote.data?.freeTypesEverything?.MorseScore || {}),
                [diagnosisName]: generatedHtml,
              },
            },
          },
        },
      }))
    }
  }, [diagnosisName, morseData])

  const handleBlur = () => {
    if (!tempHtml.trim()) return

    setPatientDBdata((prev) => ({
      ...prev,
      currentNote: {
        ...prev?.currentNote,
        data: {
          ...prev?.currentNote?.data,
          freeTypesEverything: {
            ...(prev?.currentNote?.data?.freeTypesEverything || {}),
            MorseScore: {
              ...(prev?.currentNote?.data?.freeTypesEverything?.MorseScore || {}),
              [diagnosisName]: tempHtml,
            },
          },
        },
      },
      allNotes: prev?.allNotes?.map((note) => {
        if (note?.id === noteID) {
          const parsedData = note?.data ? JSON.parse(note.data) : {}
          return {
            ...note,
            data: JSON.stringify({
              ...parsedData,
                freeTypesEverything: {
                    ...(parsedData?.freeTypesEverything || {}),
                    MorseScore: {
                        ...(parsedData?.freeTypesEverything?.MorseScore || {}),
                        [diagnosisName]: tempHtml,
                    }
                    },
            }),
          }
        }
        return note
      }),
    }))
  }
  if (!isHavingMorseScore) {
    return null
  }

  return (
    <div className="w-100 my-4">
      <div style={{ width: '30%' }}>Morse Score</div>
      <Editor
        value={tempHtml}
        onChange={(e) => setTempHtml(e.target.value)}
        onBlur={handleBlur}
        containerProps={{
          style: {
            width: '100%',
            background: '#2D2D2D',
            color: 'white',
            border: 0,
          },
        }}
      >
        <Toolbar hidden />
      </Editor>
    </div>
  )
}

export default MorseCodeProvider
